<template>
    <span v-if="error" class="form-error">
        {{ error }}
    </span>
</template>

<script>
    import get from 'lodash-es/get';

    export default {
        props: {
            errorMessage: {
                required: false,
                type: String,
                default: '',
            },
            errors: {
                type: Object,
                default: null,
            },
            name: {
                type: String,
                default: null,
            },
        },
        computed: {
            error() {
                if (this.errorMessage) {
                    return this.errorMessage;
                }

                return get(this.errors, this.name, [])[0];
            },
        },
    };
</script>
